import * as React from "react";
import {useRef} from "react";
import {ICurrentStyles} from "shubhform/utils";

interface ITextFieldProps {
    type: string;
    index?: number;
    placeholder?: string;
    value: any;
    fieldName: string;
    onChangeHandler: any;
    errorMsg: string;
    disabled?: boolean;
    label?: string;
    showLoading?: boolean;
    showCheck?: boolean;
    display?: boolean;
    currentStyles: ICurrentStyles;
    successFullyUploaded?: boolean;
}
const fileReader = (e, props) => {
    const files = e.target.files;
    const fr = new FileReader();
    fr.onload = (evt) => {
        const b64 = window.btoa((evt.target as any).result);
        props.onChangeHandler(props.index, b64);
    };
    fr.readAsBinaryString(files[0]);
}
const UploadDoc: React.FC<ITextFieldProps> = (props) => {
    const style = props.currentStyles.inputStyle;
    const inputRef = useRef(null);
    if (props.disabled) {
        style.backgroundColor = "#e7e7e7";
        style.cursor = "not-allowed";
    }
    const cameraIconStyle = {
        fontSize: "25px",
        color: "#f88410",
        marginLeft: "13px",
    };
    // what the fuck is this, all these are utils ehh
    return (
        <div style={props.currentStyles.containerStyle}>
            <input
                ref={inputRef}
                id={props.fieldName}
                style={{display: "none"}}
                type={props.type}
                disabled={props.disabled ? props.disabled : false}
                onChange={(e) => fileReader(e, props)}
            />
            <div style={style} onClick={() => inputRef.current.click()}>
                <span>
                    {props.label}
                </span>
                <span>
                    <label>
                        <span style={cameraIconStyle}> &#43;</span>
                    </label>
                </span>
                {props.successFullyUploaded && <span> &#9989;</span>}
            </div>
            <div style={props.currentStyles.errorStyle}>
                {props.errorMsg}
            </div>
        </div>
    );
};

export default UploadDoc;
